import { Station } from '@mi-front/core';
import { useYoutubeRecentBroadcasts } from './useYoutubeRecentBroadcasts';
import { YoutubeBroadcastItem } from '../item/YoutubeBroadcastItem';
import { YoutubeBroadcastsEmptyState } from './YoutubeBroadcastsEmptyState';
import { YoutubeRecentBroadcastsShell } from './YoutubeRecentBroadcastsShell';

interface YoutubeRecentBroadcastsContentProps {
  station: Station;
}

/** Resolves recent YouTube broadcasts and renders the list or an empty-state message. */
export function YoutubeRecentBroadcastsContent({ station }: YoutubeRecentBroadcastsContentProps) {
  const { data } = useYoutubeRecentBroadcasts(station.id);
  const broadcasts = data?.data ?? [];

  if (broadcasts.length === 0) {
    return <YoutubeBroadcastsEmptyState />;
  }

  return (
    <YoutubeRecentBroadcastsShell stationSlug={station.slug}>
      {broadcasts.map((broadcast) => (
        <YoutubeBroadcastItem
          key={`${broadcast.streamStartedAt}-${broadcast.streamEndedAt}`}
          broadcast={broadcast}
          stationSlug={station.slug}
        />
      ))}
    </YoutubeRecentBroadcastsShell>
  );
}
